var exports = {
  "i": "x61f99309--1b1036--wrapper",
  "D": "x61f99309--1b1036--title",
};

module.exports = exports;
